var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Modal, ModalBody, ModalFoot, ModalHead } from '@dixa/lib-shared-habla';
import { useState } from 'react';
import { facebookMessengerApi } from 'apis/facebookMessenger';
import { QueueSelect } from 'components/queueSelect';
import { NotificationType, useNotifications } from 'hooks/useNotifications';
import { createAppModal } from 'utils/modal';
import { useAppSelector } from 'utils/redux/useAppSelector';
import styles from './facebookConnectModal.module.scss';
/** A component that displays a facebook login modal and it's associated modal. */
export const FacebookConnectModal = createAppModal({ type: 'settings:facebookConnect' }, ({ isOpen, modal, hide }) => {
    const notify = useNotifications();
    const [updateFacebookConnect, { isLoading }] = facebookMessengerApi.useUpdateFacebookConnectMutation();
    const { appId, facebookAuthenticationData } = modal.arg;
    const [queueId, setQueueId] = useState();
    const organizationId = useAppSelector((state) => { var _a; return (_a = state.app.organization) === null || _a === void 0 ? void 0 : _a.id; });
    /** Handles closing the modal. */
    const handleClose = () => {
        setQueueId(undefined);
        hide === null || hide === void 0 ? void 0 : hide();
    };
    /** Handles confirming the queue. */
    const handleQueueConfirm = () => __awaiter(void 0, void 0, void 0, function* () {
        if (!organizationId)
            return;
        try {
            yield updateFacebookConnect({
                default_queue_id: queueId,
                organization_id: organizationId,
                application_id: appId,
                user_id: facebookAuthenticationData === null || facebookAuthenticationData === void 0 ? void 0 : facebookAuthenticationData.userId,
                user_access_token: facebookAuthenticationData === null || facebookAuthenticationData === void 0 ? void 0 : facebookAuthenticationData.accessToken,
                connect_facebook: true,
                connect_instagram: false,
            }).unwrap();
            notify({
                title: 'Facebook page successfully connected',
                time: 3000,
            }, NotificationType.Success);
            handleClose();
        }
        catch (_a) {
            notify({
                title: 'An error occured while connecting the facebook page',
            }, NotificationType.Error);
        }
    });
    return (_jsxs(Modal, Object.assign({ isOpen: isOpen, onClose: handleClose, className: styles.modal }, { children: [_jsx(ModalHead, { title: "Facebook for business", onClose: handleClose }), _jsx(ModalBody, { children: _jsx(QueueSelect, { onSelect: (queue) => setQueueId(queue.id) }) }), _jsx(ModalFoot, { confirmName: "Continue", confirmOnClick: handleQueueConfirm, confirmProps: {
                    disabled: queueId === undefined,
                    isLoading,
                }, cancelOnClick: handleClose })] })));
});
